import { axiosPost } from '../axios/axios.config';

// export const getAnalyticsData = async (data) => {
//   const response = await axiosPost('analytics/api/query/genericquery', data);
//   return response;
// };

export const getAnalyticsData = async (data) => {
  const response = await axiosPost('analytics/api/query/mobilecalls', data);
  return response;
};
